module.exports = __webpack_public_path__ + "img/carpeal.218c61a9.png";